module.exports = __webpack_public_path__ + "static/media/mia-logo.fe66b876.png";